<script setup lang="ts">
const props = defineProps<{
  message: string;
}>();
</script>

<template>
  <div class="banner">
    <span v-html="message"></span>
  </div>
</template>

<style lang="scss">
.banner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40px;
  background-color: $color-primary-darken;
  color: $color-neutral-white;

  a {
    color: $color-neutral-white;
  }
}
</style>
